import { Box, styled } from '@mui/material';

interface AvatarStyleProps {
  size?: number;
}

export const StyledAvatar = styled(Box)<AvatarStyleProps>(({ size }) => ({
  '> :first-child': {
    width: size ? `${size}px` : '11.56rem',
    height: size ? `${size}px` : '11.56rem',
    display: 'block',
    margin: '0 auto',
  },
}));
